import { calculateKDV } from '@utils/kdv';
import { formatCurrency } from './StockIndicator';

/**
 * KDVSummary — Modal içinde kullanılan anlık KDV hesaplama özeti
 *
 * Birim fiyat, miktar ve KDV oranı değiştiğinde otomatik güncellenir.
 * Read-only — sadece hesaplama sonucunu gösterir.
 */
export default function KDVSummary({ unitPrice, quantity, vatRate }) {
    const result = calculateKDV({ unitPrice, quantity, vatRate });

    // Hiçbir değer girilmemişse gösterme
    if (!unitPrice && !quantity) return null;

    return (
        <div className="bg-bg-tertiary/50 rounded-lg border border-border-light p-4">
            <p className="text-xs font-medium text-text-muted uppercase tracking-wider mb-3">
                KDV Hesaplama
            </p>
            <div className="grid grid-cols-3 gap-4">
                <div>
                    <p className="text-xs text-text-muted mb-1">KDV Hariç</p>
                    <p className="text-sm font-semibold text-text-primary">
                        {formatCurrency(result.toplamHaric)}
                    </p>
                </div>
                <div className="text-center">
                    <p className="text-xs text-text-muted mb-1">KDV (%{result.kdvOrani})</p>
                    <p className="text-sm font-semibold text-warning">
                        {formatCurrency(result.kdvTutari)}
                    </p>
                </div>
                <div className="text-right">
                    <p className="text-xs text-text-muted mb-1">KDV Dahil</p>
                    <p className="text-sm font-bold text-success">
                        {formatCurrency(result.toplamDahil)}
                    </p>
                </div>
            </div>
        </div>
    );
}
